import AntdTreeSelect from 'antd/lib/tree-select'
import type { TreeSelectProps as AntdTreeSelectProps } from 'antd/lib/tree-select'
import type { TreeNodeValue } from 'antd/lib/tree-select/interface'
import { connectReadonlyComponent } from '../connect'
import { PreviewText } from '../preview-text'

import 'antd/lib/tree-select/style'

export * from 'antd/lib/tree-select'

export type TreeSelectProps<T extends TreeNodeValue> = AntdTreeSelectProps<T> & {
  readonly?: boolean
}

export const TreeSelect = connectReadonlyComponent(AntdTreeSelect, PreviewText.TreeSelect)

export default TreeSelect
